
export class ApiRepeatCondition {
conditionType: string;
conditionValue: string;
field: string;
}

